<template>
  <div>
    <NavBar>
      <template v-slot:desktop-nav>
        <button class="btn btn-nav btn-yellow my-2 my-sm-0" data-toggle="modal" data-target="#list-create-modal">
          <i class="fas fa-plus-circle mr-2"></i>
          Create List
        </button>
      </template>
      <template v-slot:mobile-nav>
        <a class="mobile-nav-icon btn-nav btn btn-yellow w-100" data-toggle="modal" data-target="#list-create-modal">
          <i class="fas fa-plus"></i>
          Create A List
        </a>
        <a class="mobile-nav-icon btn-nav-green btn btn-green w-100" data-toggle="modal" data-target="#account-settings">
          <i class="fas fa-user-cog"></i>
          Account Settings
        </a>
      </template>
    </NavBar>
    <div class="container home">
      <div class="movie-list-header">
        <h1>LISTS</h1>
      </div>
      <ListCard v-cloak v-for="list in lists" :key="list.id" :list="list"></ListCard>
      <EmptyState
        v-if="lists.length === 0"
        title="No lists yet"
        description="Create a Ranked list to start deciding what to watch with your group.">
        <template #action>
          <button class="btn btn-green" type="button" data-toggle="modal" data-target="#list-create-modal">
            Create your first list
          </button>
        </template>
      </EmptyState>
      <ListSettings :list="createList" :createMode="true" @created="created"></ListSettings>
    </div>
  </div>
</template>

<script>
import ListCard from "@/components/ListCard.vue";
import ListService from "../services/ListService";
import NavBar from "@/components/NavBar.vue";
import ListSettings from "@/components/ListSettings.vue";
import ListType from "../utilities/listTypes";
import EmptyState from "@/components/EmptyState.vue";

export default {
  name: "ListsView",
  data() {
    return {
      lists: [],
      createList: {
        listName: "",
        description: "",
        listTypeId: ListType.RANKED
      }
    };
  },
  components: {
    ListCard,
    NavBar,
    ListSettings,
    EmptyState
  },
  beforeRouteEnter(_to, _from, next) {
    ListService.getAllLists()
      .then(test => {
        next(vm => (vm.lists = test));
      })
      .catch(error => {
        return error.handleError();
      });
  },
  methods: {
    created(list) {
      list.role = list.role || { roleName: "Owner" };
      list.itemCount = list.itemCount || 0;
      list.userCount = list.userCount || 1;
      list.items = list.items || [];

      this.lists.push(list);
    }
  }
};
</script>

<style scoped>
.movie-item-body {
  margin-left: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
